import axios, { type AxiosInstance } from "axios"
import { getExhibitionHeader } from "../utils/exhibitionContext";
import type { PrintOrder } from "../Component/Application/myBadgeOrders/types"

// Configure Axios instance
const api: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://127.0.0.1:8000",
  headers: {
    "Content-Type": "application/json",
  },
})

// Add an interceptor to include the Authorization token
api.interceptors.request.use(
  (config) => {
    // Assuming you store your access token in localStorage
    const token = localStorage.getItem("accessToken")
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`
    
    Object.assign(config.headers, getExhibitionHeader());}
    return config
  },
  (error) => Promise.reject(error),
)

// Badge preview response interface
export interface BadgePreviewResponse {
  success: boolean
  message: string
  badge_data?: any
  template_config?: any
  is_preview: boolean
  person_info?: {
    name: string
    email: string
    phone: string
    has_photo: boolean
  }
}

export const BadgeService = {
  requestBadge: async (): Promise<PrintOrder> => {
    try {
      const response = await api.post("/api/badges/badge-request/my-badge/")
      return response.data
    } catch (error) {
      console.error("Error in requestBadge:", error)
      throw error
    }
  },

  getMyBadgeOrders: async (): Promise<PrintOrder[]> => {
    try {
      const response = await api.get("/api/badges/badge-request/my-orders/")
      return response.data
    } catch (error) {
      console.error("Error in getMyBadgeOrders:", error)
      throw error
    }
  },

  previewMyBadge: async (): Promise<BadgePreviewResponse> => {
    try {
      const response = await api.post("/api/badges/badge-request/preview-my-badge/")
      return response.data
    } catch (error) {
      console.error("Error in previewMyBadge:", error)
      throw error
    }
  },
}
